export var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["Pending"] = "PENDING";
    InvitationStatus["Expired"] = "EXPIRED";
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Cancelled"] = "CANCELLED";
})(InvitationStatus || (InvitationStatus = {}));
//# sourceMappingURL=InvitationStatus.js.map